/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Start_Chat_Select_Project_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Choose a project" |
*
* @param {Form_Start_Chat_Select_Project_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_start_chat_select_project_placeholder = /** @type {((inputs?: Form_Start_Chat_Select_Project_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Start_Chat_Select_Project_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle ein Projekt")
	return /** @type {LocalizedString} */ ("Choose a project")
});